export const BrowserIcon = ({ fill = '#0BB163', width = '45', height = '45', viewBox = '0 0 45 45' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
    <path
      // eslint-disable-next-line max-len
      d="M15.167 31.6667C9.98154 31.6667 7.38882 31.6667 5.77791 30.0558C4.73418 29.0121 4.3667 27.5562 4.23731 25.25H40.7633C40.634 27.5562 40.2665 29.0121 39.2227 30.0558C37.6118 31.6667 35.0191 31.6667 29.8337 31.6667H23.8753V39H29.8337C30.5931 39 31.2087 39.6156 31.2087 40.375C31.2087 41.1344 30.5931 41.75 29.8337 41.75H15.167C14.4076 41.75 13.792 41.1344 13.792 40.375C13.792 39.6156 14.4076 39 15.167 39H21.1253V31.6667H15.167Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M18.8337 4.16669H26.167C33.0809 4.16669 36.5379 4.16669 38.6858 6.31457C40.8337 8.46245 40.8337 11.9194 40.8337 18.8334V20.6667C40.8337 21.678 40.8337 22.5907 40.8217 23.4167H4.17894C4.16699 22.5907 4.16699 21.678 4.16699 20.6667V18.8334C4.16699 11.9194 4.16699 8.46245 6.31488 6.31457C8.46276 4.16669 11.9197 4.16669 18.8337 4.16669Z"
      fill={fill}
    />
  </svg>
)
